// import React, { Component } from 'react';
// import { InputText } from 'primereact/inputtext';
// import { InputNumber } from 'primereact/inputnumber';
// import { InputSwitch } from 'primereact/inputswitch';
// import { Dropdown } from 'primereact/dropdown';
// import { Toast } from 'primereact/toast';
// import { connect } from 'react-redux';
// import Messages from '../../../shared/UI/Messages/Messages';
// import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
// import { DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
// import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
// import * as actions from '../../../store/actions/index';
// import { DataTable } from 'primereact/datatable';
// import { Column } from 'primereact/column';
// import { Button } from 'primereact/button';
// import  MultiColumnMultiSelect  from '../../../shared/UI/MultiColumnMultiSelect/MultiColumnMultiSelect';

// const unitColumns = [
//     {
//         field: 'label',
//         header: 'Unit Name'
//     },
//     {
//         field: 'value',
//         header: 'Code'
//     }
// ];

// const modifierColumns = [
//     { field: 'value', header: 'ID' },
//     { field: 'label', header: 'Modifier Name' },
// ];

// class AddMenuitem extends Component {
//     state = {
//         type: 'add',
//         menuItemId: null,
//         isActive: true,
//         menuCategoryId: null,
//         menuCode: '',
//         menuName: '',
//         sellingPrice: null,
//         baseunit: null,
//         CompanyId: this.props.loggedUserDetail.CompanyId,
//         createdBy: this.props.loggedUserDetail.userName ?? 'Admin',
//         createdDate: new Date(),
//         touch: false,
//         conversionRows: [
//     { id: Date.now(), fromUnit: null, toUnit: null, conversionFactor: null }
// ],
//         selectedcategory: [],
//         selectedModifiers: [],
//     }
    

//     componentDidMount() {
//         this.getAccess = HASACCESS(USER_SUBMENU_ID);
//         let id = this.props.match.params.id;
//         this.props.getMasterKeywordList('unit');
//         this.props.getMasterKeywordList('Menucategory');
//         this.props.getMasterKeywordList('Modifier');
//          this.props.getMasterTableList(  `res/GetInvMenuItembyid?MenuItemId=${id} &`,this.props.loggedUserDetail.CompanyId );
//         let type = this.props.match.params.type;
//         if (type !== 'add') {
//             this.timer();
//         }
//     }

//     timer = () => {
//         this.intervalID = setInterval(() => {
//             this.fetchSingleProcess();
//         }, 2000);
//     }

//     componentWillUnmount() {
//         if (this.props.tableLists.usersList !== undefined) {
//             clearInterval(this.intervalID);
//         }
//     }

//     fetchSingleProcess = () => {
//         let type = this.props.match.params.type;
//         let storageItems = [];
//         if (this.props.tableLists.usersList !== undefined) {
//             storageItems = this.props.tableLists.users;
//             clearInterval(this.intervalID);
//         }
//         if (storageItems) {
//             let filterData = storageItems;
//             if (filterData) {
//                   const modifierList = this.props.modifierList || [];
//                 const savedIds = filterData.allowedmodifier
//                     ? filterData.allowedmodifier.split(',').map(s => s.trim()).filter(Boolean)
//                     : [];
//                 const selectedModifiers = modifierList.filter(m =>
//                     savedIds.includes(String(m.value))
//                 );
//                 this.setState({
//                     type: type,
//                     menuItemId: filterData.menuItemId,
//                     isActive: filterData.isActive,
//                     menuCategoryId: filterData.menuCategoryId,
//                     menuCode: filterData.menuCode,
//                     menuName: filterData.menuName,
//                     sellingPrice: filterData.sellingPrice,
//                     baseunit: filterData.baseunit,
//                     selectedModifiers,
//                     // only if the API returns conversion rows
//                     conversionRows: (filterData.conversionRows && filterData.conversionRows.length > 0)
//                         ? filterData.conversionRows.map(r => ({ ...r, id: Date.now() + Math.random() }))
//                         : [{ id: Date.now(), fromUnit: null, toUnit: null, conversionFactor: null }],
//                 });
//             }
//         }
//     }

//     change = (e) => {
//         let { name, value } = e.target;
//         this.setState({ [name]: value, touch: true });
//     }

//     add = () => {

//          const allowedmodifier = this.state.selectedModifiers
//             .map(m => m.value)
//             .join(',');

//         var data = {
//             companyId: this.state.CompanyId,
//             isActive: this.state.isActive,
//             menuCategoryId: this.state.menuCategoryId,
//             menuCode: this.state.menuCode,
//             menuName: this.state.menuName,
//             sellingPrice: this.state.sellingPrice,
//             baseunit: this.state.baseunit,
//             createdBy: this.state.createdBy,
//             createdDate: this.state.createdDate,
//              allowedmodifier,
//             conversionRows: this.state.conversionRows.map(({ fromUnit, toUnit, conversionFactor }) => ({
//                 fromUnit,
//                 toUnit,
//                 conversionFactor
//                 })),
//         };

//         if (this.state.type === 'edit') {
//             data.menuItemId = this.state.menuItemId;
//         }

//         this.props.processDynamicData('invMenuItem', this.state.type, data, 'res/GetinvMenuItemList');
//     }

//     resetData = () => {
//         this.setState({
//             menuItemId: null,
//             isActive: false,
//             menuCategoryId: null,
//             menuCode: '',
//             menuName: '',
//             sellingPrice: null,
//             baseunit: null,
//             type: 'add',
//             touch: false,
//             selectedModifiers: [],
//             conversionRows: [{ id: Date.now(), fromUnit: null, toUnit: null, conversionFactor: null }]
//         });
//     }
//     addConversionRow = () => {
//     this.setState(prev => ({
//         conversionRows: [
//             ...prev.conversionRows,
//             { id: Date.now(), fromUnit: null, toUnit: null, conversionFactor: null }
//         ],
//         touch: true
//     }));
// }

// deleteConversionRow = (rowId) => {
//     this.setState(prev => ({
//         conversionRows: prev.conversionRows.filter(r => r.id !== rowId),
//         touch: true
//     }));
// }

// updateConversionRow = (rowId, field, value) => {
//     this.setState(prev => ({
//         conversionRows: prev.conversionRows.map(r =>
//             r.id === rowId ? { ...r, [field]: value } : r
//         ),
//         touch: true
//     }));
// }

// fromUnitBody = (row) => (
//     <Dropdown
//         options={this.props.unitList || []}
//         value={row.fromUnit}
//         onChange={(e) => this.updateConversionRow(row.id, 'fromUnit', e.value)}
//         placeholder="Select Unit"
//         {...DROPDOWN_CONFIG}
//     />
// )

// toUnitBody = (row) => (
//     <Dropdown
//         options={this.props.unitList || []}
//         value={row.toUnit}
//         onChange={(e) => this.updateConversionRow(row.id, 'toUnit', e.value)}
//         placeholder="Select Unit"
//         {...DROPDOWN_CONFIG}
//     />
// )

// conversionFactorBody = (row) => (
//     <InputNumber
//         value={row.conversionFactor}
//         onValueChange={(e) => this.updateConversionRow(row.id, 'conversionFactor', e.value)}
//         placeholder="Factor"
//         mode="decimal"
//         minFractionDigits={4}
//     />
// )

// deleteBody = (row) => (
//     <Button
//         icon="pi pi-trash"
//         className="p-button-danger p-button-text"
//         onClick={() => this.deleteConversionRow(row.id)}
//     />
// )

//     render() {
//         if (this.props.success) {
//             REDIRECT_TO_URL('/menuitem/', this.props);
//         }

//         let addAccess = true;
//         let editAccess = true;
//         if (this.getAccess !== undefined) {
//             if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) {
//                 this.props.history.push('/dashboard');
//             }
//             addAccess = this.getAccess.addAccess === true;
//             editAccess = this.getAccess.editAccess === true;
//         }
//         let accessButton = { addAccess: addAccess, editAccess: editAccess };

//         let isEnabled = this.state.touch === true;

//         let redirectURL = '/menuitem/';
//         if (this.props.userDetail && this.props.match.params.id !== undefined) {
//             if (this.props.userDetail.userId === this.props.match.params.id) {
//                 redirectURL = '/dashboard';
//             }
//         }

//         return (
//             <div className="p-grid">
//                 {this.props.loading && <div className="page-loader"></div>}
//                 {this.props.error !== null && <Messages type="error" message={this.props.error} />}
//                 {this.props.success !== null && <Messages type="success" message={this.props.success} />}
//                 <Toast ref={(el) => this.growl = el} />
//                 <div className="p-col-12">
//                     <div className="card card-w-title" style={{ position: 'relative' }}>
//                         <h1>{this.state.type} Item</h1>

//                         <div className="p-grid mt1">
//                             <div className="p-col-12">
//                                 <div className="card card-w-title">
//                                     <div className="p-grid">
//                                         <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="label" htmlFor="menuCategoryId">Menu Category <span className="requiredColor">*</span></label>
//                                             <div className="mt1">

//                                         <MultiColumnMultiSelect
//                                         multiple={false}
//                                         value={this.state.selectedcategory}
//                                         options={this.props.CategoryList || []}
//                                         optionValue="value"
//                                         optionLabel="label"
//                                         columns={[
//                                             {
//                                                 field: 'id',
//                                                 header: 'ID'
//                                             },
//                                             {
//                                                 field: 'label',
//                                                 header: 'Unit Name'
//                                             },
//                                         ]}
//                                         placeholder="Select Category"
//                                         onChange={(selectedcategory) =>
//                                             this.setState({
//                                                 selectedcategory,
//                                                 touch: true
//                                             })
//                                         }
//                                         />
//                                         </div>
//                                         </div>

//                                         {/* isActive - Switch */}
//                                         <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="labeltop" htmlFor="isActive">Is Active</label>
//                                             <div className="mt1">
//                                                 <InputSwitch
//                                                     id="isActive"
//                                                     name="isActive"
//                                                     checked={this.state.isActive}
//                                                     onChange={(e) => this.setState({ isActive: e.value, touch: true })}
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* menuCategoryId - Dropdown */}
//                                         {/* <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="label" htmlFor="menuCategoryId">Menu Category <span className="requiredColor">*</span></label>
//                                             <div className="mt1">
//                                                 <Dropdown
//                                                     className="p-col-12"
//                                                     id="menuCategoryId"
//                                                     name="menuCategoryId"
//                                                     options={this.props.CategoryList || []}
//                                                     value={this.state.menuCategoryId}
//                                                     onChange={(e) => this.setState({ menuCategoryId: e.value, touch: true })}
//                                                     placeholder="Select Menu Category"
//                                                     {...DROPDOWN_CONFIG}
//                                                 />
//                                             </div>
//                                         </div> */}

//                                         {/* menuCode - InputText */}
//                                         <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="labeltop" htmlFor="menuCode">Menu Code <span className="requiredColor">*</span></label>
//                                             <div className="mt1">
//                                                 <InputText
//                                                     className="p-col-12"
//                                                     id="menuCode"
//                                                     name="menuCode"
//                                                     value={this.state.menuCode}
//                                                     onChange={this.change}
//                                                     placeholder="Menu Code"
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* menuName - InputText */}
//                                         <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="labeltop" htmlFor="menuName">Menu Name <span className="requiredColor">*</span></label>
//                                             <div className="mt1">
//                                                 <InputText
//                                                     className="p-col-12"
//                                                     id="menuName"
//                                                     name="menuName"
//                                                     value={this.state.menuName}
//                                                     onChange={this.change}
//                                                     placeholder="Menu Name"
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* sellingPrice - InputNumber */}
//                                         <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="labeltop" htmlFor="sellingPrice">Selling Price <span className="requiredColor">*</span></label>
//                                             <div className="mt1">
//                                                 <InputNumber
//                                                     // className="p-col-12"
//                                                     id="sellingPrice"
//                                                     name="sellingPrice"
//                                                     value={this.state.sellingPrice}
//                                                     onValueChange={(e) => this.setState({ sellingPrice: e.value, touch: true })}
//                                                     placeholder="Selling Price"
//                                                     mode="decimal"
//                                                     minFractionDigits={2}
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* baseunit - Dropdown */}
//                                         <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="label" htmlFor="baseunit">Base Unit <span className="requiredColor">*</span></label>
//                                             <div className="mt1">
//                                                 <Dropdown
//                                                     className="p-col-12"
//                                                     id="baseunit"
//                                                     name="baseunit"
//                                                     options={this.props.unitList || []}
//                                                     value={this.state.baseunit}
//                                                     onChange={(e) => this.setState({ baseunit: e.value, touch: true })}
//                                                     placeholder="Select Base Unit"
//                                                     {...DROPDOWN_CONFIG}
//                                                 />
//                                             </div>
//                                         </div>
                                        
//                                         {/* ── Allowed Modifiers ─────────────────────────────── */}
//                                         <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="label" htmlFor="allowedmodifier">
//                                                 Allowed Modifiers
//                                             </label>
//                                             <div className="mt1">
//                                                 <MultiColumnMultiSelect
//                                                     multiple={true}
//                                                     value={this.state.selectedModifiers}
//                                                     options={this.props.modifierList || []}
//                                                     optionValue="value"
//                                                     optionLabel="label"
//                                                     columns={modifierColumns}
//                                                     placeholder="Select Modifiers"
//                                                     onChange={(selectedModifiers) =>
//                                                         this.setState({ selectedModifiers, touch: true })
//                                                     }
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* Unit Conversion Table */}
//                                    <div className="p-col-12">
//                                     <div className="card card-w-title">
//                                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                             <h1>Unit Conversion</h1>
//                                             <Button label="Add Row" icon="pi pi-plus" className="p-button-sm" onClick={this.addConversionRow} />
//                                         </div>

//                                         <DataTable value={this.state.conversionRows}>

//                                             <Column
//                                                 header="Conversion"
//                                                 body={(row) => (
//                                                     <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>

//                                                         {/* 1 */}
//                                                         <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>1</span>

//                                                         {/* From Unit */}
//                                                         <Dropdown
//                                                             options={this.props.unitList || []}
//                                                             value={row.fromUnit}
//                                                             onChange={(e) => this.updateConversionRow(row.id, 'fromUnit', e.value)}
//                                                             placeholder="From Unit"
//                                                             style={{ width: '160px' }}
//                                                             {...DROPDOWN_CONFIG}
//                                                         />

//                                                         {/* = */}
//                                                         <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>=</span>

//                                                         {/* Conversion Factor */}
//                                                         <InputNumber
//                                                             value={row.conversionFactor}
//                                                             onValueChange={(e) => this.updateConversionRow(row.id, 'conversionFactor', e.value)}
//                                                             placeholder="Factor"
//                                                             // mode="number"
//                                                             // minFractionDigits={4}
//                                                             inputStyle={{ width: '130px' }}
//                                                         />

//                                                         {/* x */}
//                                                         <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>x</span>

//                                                         {/* To Unit */}
//                                                         <Dropdown
//                                                             options={this.props.unitList || []}
//                                                             value={row.toUnit}
//                                                             onChange={(e) => this.updateConversionRow(row.id, 'toUnit', e.value)}
//                                                             placeholder="To Unit"
//                                                             style={{ width: '160px' }}
//                                                             {...DROPDOWN_CONFIG}
//                                                         />

//                                                     </div>
//                                                 )}
//                                             />

//                                             <Column
//                                                 header="Action"
//                                                 style={{ width: '70px', textAlign: 'center' }}
//                                                 body={(row) => (
//                                                     <Button
//                                                         icon="pi pi-trash"
//                                                         className="p-button-danger p-button-text"
//                                                         onClick={() => this.deleteConversionRow(row.id)}
//                                                     />
//                                                 )}
//                                             />

//                                         </DataTable>
//                                     </div>
//                                 </div>
//                                         <div className="p-col-12 p-lg-12">

//                                 <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={redirectURL} />
                            
//                             </div>

//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         );
//     }
// }

// const mapStateToProps = state => {
//     return {
//         loggedUserDetail: state.auth.userObject,
//         userDetail: state.auth.userDetail,
//         loading: state.master.loading,
//         error: state.master.error,
//         success: state.master.success,
//         tableLists: state.master.tableLists,
//         unitList: state.keyword.unit,
//         CategoryList: state.keyword.Menucategory,
//         modifierList: state.keyword.modifier,  
//     };
// };

// const mapDispatchToProps = dispatch => {
//     return {
//         getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
//         getMasterTableList: (table, companyId) => dispatch(actions.getMasterTableList(table, companyId)),
//         processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
//     };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(AddMenuitem);

import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { InputSwitch } from 'primereact/inputswitch';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { connect } from 'react-redux';
import Messages from '../../../shared/UI/Messages/Messages';
import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Editor } from 'primereact/editor';
import jsPDF from 'jspdf';
import axios from '../../../axios-url';
import { chenthoorLandscapeLogo } from '../../../shared/fontsAndBitImages';
import { MultiSelect } from 'primereact/multiselect';

// Method editor helper (same as the SOP editors in Position Master): values are stored as HTML,
// plain text is converted to HTML paragraphs so line breaks survive in the editor.
const looksLikeHtml = (value) => /<\/?[a-z][\s\S]*>/i.test(value || '');

const escapeHtml = (value) => String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

const toEditorHtml = (value) => {
    if (!value) { return ''; }
    if (looksLikeHtml(value)) { return value; }
    return String(value).split(/\r?\n/).map(line => '<p>' + (escapeHtml(line) || '<br>') + '</p>').join('');
};

class AddMenuitem extends Component {
    state = {
        type: 'add',
        menuItemId: null,
        isActive: true,
        menuCategoryId: null,
        menuCode: '',
        menuName: '',
        sellingPrice: null,
        baseunit: null,
        defaultkitchen: null,
        defaultstore: null,
        CompanyId: this.props.loggedUserDetail.CompanyId,
        createdBy: this.props.loggedUserDetail.userName ?? 'Admin',
        createdDate: new Date(),
        touch: false,
        conversionRows: [
            { id: Date.now(), fromUnit: null, toUnit: null, conversionFactor: null }
        ],
        componentRows: [
            { id: Date.now(), menuComponent: null, portion: null, unit: null }
        ],
        selectedcategory: [],
        theStory: '',
        character: '',
        chiefNote: '',
        method: '',
        // selectedModifiers holds the selected modifier ids (array of strings);
        // we derive the comma-separated string at save time.
        selectedModifiers: [],
    }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        let id = this.props.match.params.id;
        this.props.getMasterKeywordList('uom');
        this.props.getMasterKeywordList('Menucategory');
        this.props.getMasterKeywordList('modifier');   // ← fetch modifier master
        this.props.getMasterKeywordList('Kitchen');
        this.props.getMasterKeywordList('StorageLocation');
        this.props.getMasterKeywordList('MenuComponent');
        this.props.getMasterKeywordList('Ingredient');
        let type = this.props.match.params.type;
        if (type !== 'add') {
            this.fetchSingleProcess(id);
        }
    }

    fetchSingleProcess = (id) => {
        this.props.getMasterTableList(
            `res/GetInvMenuItembyid?MenuItemId=${id}`,
            this.state.CompanyId
        );
    }

    componentDidUpdate(prevProps) {
        const type = this.props.match.params.type;
        if (type === 'add') return;

        const filterData    = this.props.tableLists?.invMenuItem;
        const prevFilterData = prevProps.tableLists?.invMenuItem;

        const categoryList = this.props.CategoryList || [];
        const prevCategoryList = prevProps.CategoryList || [];

        // Only map into state once when the API response arrives/changes
        if (filterData && filterData !== prevFilterData) { 
            const conversionList = this.props.tableLists?.resmenuitemuomconversionlist || [];

            const componentList = this.props.tableLists?.resmenucomponentlist
                || this.props.tableLists?.invDefineComponentformenulist
                || [];

            const selectedModifiers = filterData.allowedModifier
                ? filterData.allowedModifier.split(',').map(s => s.trim()).filter(Boolean)
                : [];

            // MultiColumnMultiSelect (single-select mode) needs the whole
            // matching option object, not the raw id — see its displayText().
            const selectedcategory = categoryList.find(c => c.value === filterData.menuCategoryId) || null;

            this.setState({
                type,
                menuItemId:     filterData.menuItemId,
                isActive:       filterData.isActive,
                menuCategoryId: filterData.menuCategoryId,
                menuCode:       filterData.menuCode,
                menuName:       filterData.menuName,
                sellingPrice:   filterData.sellingPrice,
                baseunit:       filterData.baseunit,
                defaultkitchen: filterData.defaultkitchen,
                defaultstore:   filterData.defaultstore,
                theStory:       filterData.story ?? '',
                character:      filterData.character ?? '',
                chiefNote:      filterData.chefnote ?? '',
                method:         filterData.cookingmethod ?? '',
                selectedModifiers,
                selectedcategory,
                conversionRows: conversionList.length > 0
                    ? conversionList.map(r => ({ ...r, id: Date.now() + Math.random() }))
                    : [{ id: Date.now(), fromUnit: null, toUnit: null, conversionFactor: null }],
                componentRows: componentList.length > 0
                    ? componentList.map(r => ({
                        menuItemComponentId: r.menuItemComponentId ?? r.menuitemcomponentid ?? r.MenuItemComponentId,
                        menuComponent: r.menuComponentId ?? r.menuComponent,
                        portion: r.portion,
                        unit: r.unit,
                        id: Date.now() + Math.random(),
                    }))
                    : [{ id: Date.now(), menuComponent: null, portion: null, unit: null }],
            });
            return;
        }

        // CategoryList can arrive after filterData (GetMasterKeywordList and
        // GetInvMenuItembyid race independently) — re-derive once it shows up
        // so the field doesn't stay stuck blank when that happens.
        if (filterData && categoryList !== prevCategoryList && categoryList.length > 0 && !this.state.selectedcategory) {
            const selectedcategory = categoryList.find(c => c.value === filterData.menuCategoryId) || null;
            if (selectedcategory) this.setState({ selectedcategory });
        }
    }

    change = (e) => {
        let { name, value } = e.target;
        this.setState({ [name]: value, touch: true });
    }

    // Adapts the Editor's onTextChange ({ htmlValue, source }) to state, same as the SOP editors in
    // Position Master: ignore programmatic changes and unchanged content so loading a value
    // doesn't mark the form as changed.
    changeMethod = (e) => {
        if (typeof e.source === 'string' && e.source !== 'user') { return; }
        const value = e.htmlValue || '';
        if (value === toEditorHtml(this.state.method)) { return; }
        this.setState({ method: value, touch: true });
    }

    // add = () => {
    //     // Convert selectedModifiers array → comma-separated ID string
    //     const allowedModifier = this.state.selectedModifiers
    //         .map(m => m.value)
    //         .join(',');

    //     var data = {
    //         companyId: this.state.CompanyId,
    //         isActive: this.state.isActive,
    //         menuCategoryId: this.state.menuCategoryId,
    //         menuCode: this.state.menuCode,
    //         menuName: this.state.menuName,
    //         sellingPrice: this.state.sellingPrice,
    //         baseunit: this.state.baseunit,
    //         allowedModifier,             // ← "id1,id2,id3"
    //         createdBy: this.state.createdBy,
    //         createdDate: this.state.createdDate,
    //         conversionRows: this.state.conversionRows.map(
    //             ({ fromUnit, toUnit, conversionFactor }) => ({
    //                 fromUnit, toUnit, conversionFactor
    //             })
    //         ),
    //     };

    //     if (this.state.type === 'edit') {
    //         data.menuItemId = this.state.menuItemId;
    //     }

    //     this.props.processDynamicData('invMenuItem', this.state.type, data, 'res/GetinvMenuItemList');
    // }
    
    add = () => {
    // Convert selectedModifiers array → comma-separated ID string (or null if empty)
    const allowedModifier = this.state.selectedModifiers.length
        ? this.state.selectedModifiers.join(',')
        : null;

    const isEdit = this.state.type === 'edit';

    // Add: menuItemId is omitted entirely. Edit: it is included.
    const invMenuItem = {
        ...(isEdit && { menuItemId: this.state.menuItemId }),
        companyid: this.state.CompanyId,
        menuCode: this.state.menuCode,
        menuName: this.state.menuName,
        menuCategoryId: this.state.menuCategoryId,
        sellingPrice: this.state.sellingPrice,
        isActive: this.state.isActive,
        baseunit: this.state.baseunit,
        defaultkitchen: this.state.defaultkitchen,
        allowedModifier,
        photopath: isEdit ? `${this.state.menuItemId}.png` : this.state.photopath,
        breakfastqty: null,
        lunchqty: null,
        dinnerqty: null,
        validateproductionplanqty: null,
        defaultstore: this.state.defaultstore,
        story: this.state.theStory,
        character: this.state.character,
        chefnote: this.state.chiefNote,
        cookingmethod: this.state.method,
    };

    // Add: menuItemComponentId / menuItemId are omitted entirely.
    // Edit: both are included for rows that already exist.
    const invDefineComponentformenulist = this.state.componentRows
        .filter(r => r.menuComponent !== null || r.portion !== null || r.unit !== null)
        .map(r => ({
            ...(isEdit && r.menuItemComponentId && { menuItemComponentId: r.menuItemComponentId }),
            ...(isEdit && { menuItemId: this.state.menuItemId }),
            menuComponentId: r.menuComponent,
            companyid: this.state.CompanyId,
            portion: r.portion,
            isActive: true,
            unit: r.unit,
        }));

    const data = {
        invMenuItem,
        invDefineComponentformenulist,
        resmenuitemuomconversionlist: this.state.conversionRows.map(
            ({ fromUnit, toUnit, conversionFactor }) => ({
                fromUnit,
                toUnit,
                conversionFactor,
            })
        ),
    };

    this.props.processDynamicData('invMenuItem', this.state.type, data, 'res/GetinvMenuItemList');
}

    // Builds the recipe-card PDF from the GetInvMenuItembyid response (already held in tableLists).
    // The layout is drawn directly with jsPDF; no template file is loaded.
    // Ingredients come from the item's recipe: find the recipe for this menu item in the recipe list,
    // then load it with GetInvRecipebyid and map each invRecipeDetail row to name + quantity/unit.
    fetchRecipeIngredients = async (menuItemId) => {
        const labelOf = (options, value) => {
            const o = (options || []).find(x => String(x.value).toLowerCase() === String(value).toLowerCase());
            return o ? o.label : '';
        };
        try {
            const companyId = this.state.CompanyId;
            const listResponse = await axios.get(`/master/api/res/GeInvRecipeList?companyId=${companyId}`);
            const recipes = (listResponse.data || []).filter(r => String(r.menuItemId).toLowerCase() === String(menuItemId).toLowerCase());
            if (!recipes.length) { return []; }
            // If an item has several recipe versions, use the most recent effective date
            recipes.sort((a, b) => new Date(b.effectiveDate || 0) - new Date(a.effectiveDate || 0));
            const recipeResponse = await axios.get(`/master/api/res/GetInvRecipebyid?recipeid=${recipes[0].recipeId}&companyId=${companyId}`);
            const details = (recipeResponse.data && recipeResponse.data.invRecipeDetail) || [];
            return details.map(r => {
                const unit = labelOf(this.props.unitList, r.uomid);
                return {
                    name: labelOf(this.props.IngredientList, r.ingredientId) || r.ingredientName || '',
                    qty: (r.quantity !== null && r.quantity !== undefined) ? `${r.quantity} ${unit}`.trim() : '',
                };
            });
        } catch (err) {
            return [];
        }
    }

    downloadPdf = async () => {
        const menuItem = this.props.tableLists?.invMenuItem;
        if (!menuItem) { return; }
        const ingredients = await this.fetchRecipeIngredients(menuItem.menuItemId);
        // The logo is far larger than the 32 x 16 mm it is printed at, which is what bloats the file.
        // Downscale it (still ~380 dpi at print size, transparency kept) before embedding.
        const img = new Image();
        img.onload = () => {
            const targetWidth = Math.min(img.naturalWidth, 480);
            const canvas = document.createElement('canvas');
            canvas.width = targetWidth;
            canvas.height = Math.round(img.naturalHeight * targetWidth / img.naturalWidth);
            canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
            this.buildPdf(canvas.toDataURL('image/png'), ingredients);
        };
        img.onerror = () => this.buildPdf(chenthoorLandscapeLogo, ingredients);
        img.src = chenthoorLandscapeLogo;
    }

    buildPdf = (logoData, ingredients) => {
        const data = this.props.tableLists || {};
        const item = data.invMenuItem;
        if (!item) { return; }

        const BROWN = [122, 72, 8];
        const BEIGE = [236, 232, 222];
        const ROW_ALT = [228, 224, 213];
        const ROW = [242, 240, 233];
        const DARK = [51, 51, 51];
        const MUTED = [110, 110, 110];

        const labelOf = (options, value) => {
            const o = (options || []).find(x => String(x.value).toLowerCase() === String(value).toLowerCase());
            return o ? o.label : '';
        };

        // Ingredient rows come from the recipe (GetInvRecipebyid), see fetchRecipeIngredients
        const components = ingredients || [];

        // Method is stored as editor HTML (or plain text for older records): one step per paragraph / list item
        const methodSteps = (value) => {
            if (!value) { return []; }
            let parts = [];
            if (/<\/?[a-z][\s\S]*>/i.test(value)) {
                const div = document.createElement('div');
                div.innerHTML = value;
                const nodes = div.querySelectorAll('li, p');
                if (nodes.length) { nodes.forEach(n => parts.push(n.textContent)); } else { parts = (div.textContent || '').split(/\r?\n/); }
            } else {
                parts = String(value).split(/\r?\n/);
            }
            return parts.map(t => t.trim().replace(/^\d+[.)]\s*/, '')).filter(Boolean);
        };

        const doc = new jsPDF({ unit: 'mm', format: 'a4', compress: true });
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const margin = 12;
        const contentWidth = pageWidth - margin * 2;
        const bottomLimit = pageHeight - 16;
        const gap = 5;
        const barHeight = 9;
        const lineMm = 4.8;
        let y = 0;

        const setFill = (c) => doc.setFillColor(c[0], c[1], c[2]);
        const setText = (c) => doc.setTextColor(c[0], c[1], c[2]);
        const ensureSpace = (h) => { if (y + h > bottomLimit) { doc.addPage(); y = 15; } };

        const bar = (x, yy, w, title) => {
            setFill(BROWN);
            doc.rect(x, yy, w, barHeight, 'F');
            setText([255, 255, 255]);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(11);
            doc.text(title, x + 4, yy + 6.2);
        };

        const textLines = (text, w) => {
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(10);
            return doc.splitTextToSize(text || '-', w - 8);
        };
        const textBoxHeight = (lines) => barHeight + lines.length * lineMm + 6;
        const drawTextBox = (x, yy, w, title, lines, h) => {
            bar(x, yy, w, title);
            setFill(BEIGE);
            doc.setDrawColor(190, 180, 160);
            doc.rect(x, yy + barHeight, w, h - barHeight, 'FD');
            setText(DARK);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(10);
            doc.text(lines, x + 4, yy + barHeight + 6);
        };

        // Header: logo + restaurant name
        doc.addImage(logoData, 'PNG', margin, 6, 32, 16, 'chenthoorLogo', 'FAST');
        setText(BROWN);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(17);
        doc.text('CHENTHOOR RESTAURANT', pageWidth / 2, 16, { align: 'center' });
        setFill(BROWN);
        doc.rect(margin, 25, contentWidth, 0.8, 'F');

        // Title and subtitle
        y = 37;
        setText(BROWN);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(22);
        doc.text(String(item.menuName || '').toUpperCase(), margin, y);
        y += 6;
        const subtitle = [
            labelOf(this.props.CategoryList, item.menuCategoryId),
            item.menuCode,
            item.baseunit ? labelOf(this.props.unitList, item.baseunit) : '',
        ].filter(Boolean).join('  •  ');
        setText(MUTED);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9);
        doc.text(subtitle, margin, y);
        y += 7;

        // The Story
        const storyLines = textLines(item.story, contentWidth);
        const storyH = textBoxHeight(storyLines);
        ensureSpace(storyH);
        drawTextBox(margin, y, contentWidth, 'THE STORY', storyLines, storyH);
        y += storyH + 6;

        // Menu Item (menuName from GetInvMenuItembyid)
        const menuItemLines = [item.menuName || '-'];
        const menuItemH = textBoxHeight(menuItemLines);
        ensureSpace(menuItemH);
        drawTextBox(margin, y, contentWidth, 'MENU ITEM', menuItemLines, menuItemH);
        y += menuItemH + 6;

        // Ingredient table (left) + Method (right)
        const leftW = 96;
        const rightW = contentWidth - leftW - gap;
        const rowH = 6.4;
        const qtyX = leftW * 0.62;
        const steps = methodSteps(item.cookingmethod).map(s => {
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(10);
            const lines = doc.splitTextToSize(s, rightW - 14);
            return { lines, h: Math.max(lines.length * lineMm + 4, 9) };
        });
        const leftH = barHeight + Math.max(components.length, 1) * rowH;
        const rightH = barHeight + steps.reduce((sum, s) => sum + s.h, 0) + (steps.length ? 0 : 9);
        ensureSpace(Math.max(leftH, rightH));

        bar(margin, y, leftW, 'INGREDIENT');
        setText([255, 255, 255]);
        doc.text('QTY.', margin + qtyX + 2, y + 6.2);
        components.forEach((c, i) => {
            const ry = y + barHeight + i * rowH;
            setFill(i % 2 === 0 ? ROW : ROW_ALT);
            doc.rect(margin, ry, leftW, rowH, 'F');
            setText(DARK);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(9.5);
            doc.text(c.name || '-', margin + 3, ry + 4.4);
            doc.text(c.qty, margin + qtyX + 2, ry + 4.4);
        });

        const rx = margin + leftW + gap;
        bar(rx, y, rightW, 'METHOD');
        let sy = y + barHeight;
        steps.forEach((s, i) => {
            setFill(i % 2 === 0 ? ROW : ROW_ALT);
            doc.rect(rx, sy, rightW, s.h, 'F');
            setText(DARK);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(10);
            doc.text(`${i + 1}.`, rx + 3, sy + 5.4);
            doc.setFont('helvetica', 'normal');
            doc.text(s.lines, rx + 10, sy + 5.4);
            sy += s.h;
        });
        y += Math.max(leftH, rightH) + 6;

        // Character | Chef Note
        const halfW = (contentWidth - gap) / 2;
        const charLines = textLines(item.character, halfW);
        const noteLines = textLines(item.chefnote, halfW);
        const boxH = Math.max(textBoxHeight(charLines), textBoxHeight(noteLines));
        ensureSpace(boxH);
        drawTextBox(margin, y, halfW, 'CHARACTER', charLines, boxH);
        drawTextBox(margin + halfW + gap, y, halfW, 'CHEF NOTE', noteLines, boxH);

        // Footer on every page
        const pages = doc.internal.getNumberOfPages();
        for (let p = 1; p <= pages; p++) {
            doc.setPage(p);
            setText(MUTED);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8);
            doc.text(`CHENTHOOR RESTAURANT  |  Page ${p}`, pageWidth - margin, pageHeight - 8, { align: 'right' });
        }

        doc.save(`${item.menuName || 'MenuItem'}.pdf`);
    }

    resetData = () => {
        this.setState({
            menuItemId: null,
            isActive: false,
            menuCategoryId: null,
            menuCode: '',
            menuName: '',
            sellingPrice: null,
            baseunit: null,
            defaultkitchen: null,
            defaultstore: null,
            type: 'add',
            touch: false,
            selectedModifiers: [],
            theStory: '',
            character: '',
            chiefNote: '',
            method: '',
            conversionRows: [{ id: Date.now(), fromUnit: null, toUnit: null, conversionFactor: null }],
            componentRows: [{ id: Date.now(), menuComponent: null, portion: null, unit: null }]
        });
    }

    addConversionRow = () => {
        this.setState(prev => ({
            conversionRows: [
                ...prev.conversionRows,
                { id: Date.now(), fromUnit: null, toUnit: null, conversionFactor: null }
            ],
            touch: true
        }));
    }

    deleteConversionRow = (rowId) => {
        this.setState(prev => ({
            conversionRows: prev.conversionRows.filter(r => r.id !== rowId),
            touch: true
        }));
    }

    updateConversionRow = (rowId, field, value) => {
        this.setState(prev => ({
            conversionRows: prev.conversionRows.map(r =>
                r.id === rowId ? { ...r, [field]: value } : r
            ),
            touch: true
        }));
    }

    addComponentRow = () => {
        this.setState(prev => ({
            componentRows: [
                ...prev.componentRows,
                { id: Date.now(), menuComponent: null, portion: null, unit: null }
            ],
            touch: true
        }));
    }

    deleteComponentRow = (rowId) => {
        this.setState(prev => ({
            componentRows: prev.componentRows.filter(r => r.id !== rowId),
            touch: true
        }));
    }

    updateComponentRow = (rowId, field, value) => {
        this.setState(prev => ({
            componentRows: prev.componentRows.map(r =>
                r.id === rowId ? { ...r, [field]: value } : r
            ),
            touch: true
        }));
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/menuitem/', this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (
                this.getAccess.viewAccess === false &&
                this.props.userDetail.userId !== this.props.match.params.id
            ) {
                this.props.history.push('/dashboard');
            }
            addAccess = this.getAccess.addAccess === true;
            editAccess = this.getAccess.editAccess === true;
        }
        let accessButton = { addAccess, editAccess };
        let isEnabled = this.state.touch === true;

        let redirectURL = '/menuitem/';
        if (this.props.userDetail && this.props.match.params.id !== undefined) {
            if (this.props.userDetail.userId === this.props.match.params.id) {
                redirectURL = '/dashboard';
            }
        }

        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>{this.state.type} Item</h1>
                        {this.state.type !== 'add' && (
                            <Button
                                type="button"
                                label="Download PDF"
                                icon="pi pi-file-pdf"
                                className="p-button-secondary"
                                style={{ position: 'absolute', top: '1em', right: '1em' }}
                                disabled={!this.props.tableLists?.invMenuItem}
                                onClick={this.downloadPdf}
                            />
                        )}

                        <div className="p-grid mt1">
                            <div className="p-col-12">
                                <div className="card card-w-title">
                                    <div className="p-grid">

                                        {/* Menu Category */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label" htmlFor="menuCategoryId">
                                                Menu Category <span className="requiredColor">*</span>
                                            </label>
                                            <div className="mt1">
                                                <Dropdown
                                                    className="p-col-12"
                                                    id="menuCategoryId"
                                                    name="menuCategoryId"
                                                    options={this.props.CategoryList || []}
                                                    value={this.state.menuCategoryId}
                                                    // Bound to menuCategoryId, which is what add() saves.
                                                    // The previous control only set selectedcategory, so a
                                                    // category picked here never reached the payload.
                                                    onChange={(e) => this.setState({
                                                        menuCategoryId: e.value,
                                                        selectedcategory: (this.props.CategoryList || [])
                                                            .find(c => c.value === e.value) || null,
                                                        touch: true,
                                                    })}
                                                    placeholder="Select Category"
                                                    {...DROPDOWN_CONFIG}
                                                />
                                            </div>
                                        </div>

                                        {/* Is Active */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="isActive">Is Active</label>
                                            <div className="mt1">
                                                <InputSwitch
                                                    id="isActive"
                                                    name="isActive"
                                                    checked={this.state.isActive}
                                                    onChange={(e) => this.setState({ isActive: e.value, touch: true })}
                                                />
                                            </div>
                                        </div>

                                        {/* Menu Code */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="menuCode">
                                                Menu Code <span className="requiredColor">*</span>
                                            </label>
                                            <div className="mt1">
                                                <InputText
                                                    className="p-col-12"
                                                    id="menuCode"
                                                    name="menuCode"
                                                    value={this.state.menuCode}
                                                    onChange={this.change}
                                                    placeholder="Menu Code"
                                                />
                                            </div>
                                        </div>

                                        {/* Menu Name */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="menuName">
                                                Menu Name <span className="requiredColor">*</span>
                                            </label>
                                            <div className="mt1">
                                                <InputText
                                                    className="p-col-12"
                                                    id="menuName"
                                                    name="menuName"
                                                    value={this.state.menuName}
                                                    onChange={this.change}
                                                    placeholder="Menu Name"
                                                />
                                            </div>
                                        </div>

                                        {/* Selling Price */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="sellingPrice">
                                                Selling Price <span className="requiredColor">*</span>
                                            </label>
                                            <div className="mt1">
                                                <InputNumber
                                                    id="sellingPrice"
                                                    name="sellingPrice"
                                                    value={this.state.sellingPrice}
                                                    onValueChange={(e) =>
                                                        this.setState({ sellingPrice: e.value, touch: true })
                                                    }
                                                    placeholder="Selling Price"
                                                    mode="decimal"
                                                    minFractionDigits={2}
                                                />
                                            </div>
                                        </div>

                                        {/* Base Unit */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label" htmlFor="baseunit">
                                                Base Unit <span className="requiredColor">*</span>
                                            </label>
                                            <div className="mt1">
                                                <Dropdown
                                                    className="p-col-12"
                                                    id="baseunit"
                                                    name="baseunit"
                                                    options={this.props.unitList || []}
                                                    value={this.state.baseunit}
                                                    onChange={(e) =>
                                                        this.setState({ baseunit: e.value, touch: true })
                                                    }
                                                    placeholder="Select Base Unit"
                                                    {...DROPDOWN_CONFIG}
                                                />
                                            </div>
                                        </div>

                                        {/* Default Kitchen */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label" htmlFor="defaultkitchen">
                                                Default Kitchen
                                            </label>
                                            <div className="mt1">
                                                <Dropdown
                                                    className="p-col-12"
                                                    id="defaultkitchen"
                                                    name="defaultkitchen"
                                                    options={this.props.KitchenList || []}
                                                    value={this.state.defaultkitchen}
                                                    onChange={(e) =>
                                                        this.setState({ defaultkitchen: e.value, touch: true })
                                                    }
                                                    placeholder="Select Default Kitchen"
                                                    {...DROPDOWN_CONFIG}
                                                />
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label" htmlFor="defaultstore">
                                                Default Store
                                            </label>
                                            <div className="mt1">
                                                <Dropdown
                                                    className="p-col-12"
                                                    id="defaultstore"
                                                    name="defaultstore"
                                                    options={this.props.StoreList || []}
                                                    value={this.state.defaultstore}
                                                    onChange={(e) =>
                                                        this.setState({ defaultstore: e.value, touch: true })
                                                    }
                                                    placeholder="Select Default Store"
                                                    {...DROPDOWN_CONFIG}
                                                />
                                            </div>
                                        </div>

                                        {/* ── Allowed Modifiers ─────────────────────────────── */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label" htmlFor="allowedModifier">
                                                Allowed Modifiers
                                            </label>
                                            <div className="mt1">
                                                <MultiSelect
                                                    className="p-col-12"
                                                    id="allowedModifier"
                                                    options={this.props.modifierList || []}
                                                    value={this.state.selectedModifiers || []}
                                                    onChange={(e) =>
                                                        this.setState({ selectedModifiers: e.value, touch: true })
                                                    }
                                                    placeholder="Select Modifiers"
                                                    showClear={false}
                                                    {...DROPDOWN_CONFIG}
                                                />
                                            </div>
                                        </div>

                                        {/* Unit Conversion Table */}
                                        <div className="p-col-12">
                                            <div className="card card-w-title">
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <h1>Unit Conversion</h1>
                                                    <Button
                                                        label="Add Row"
                                                        icon="pi pi-plus"
                                                        className="p-button-sm"
                                                        onClick={this.addConversionRow}
                                                    />
                                                </div>

                                                <DataTable value={this.state.conversionRows}>
                                                    <Column
                                                        header="Conversion"
                                                        body={(row) => (
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>1</span>
                                                                <Dropdown
                                                                    options={this.props.unitList || []}
                                                                    value={row.fromUnit}
                                                                    onChange={(e) => this.updateConversionRow(row.id, 'fromUnit', e.value)}
                                                                    placeholder="From Unit"
                                                                    style={{ width: '160px' }}
                                                                    {...DROPDOWN_CONFIG}
                                                                />
                                                                <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>=</span>
                                                                <InputNumber
                                                                    value={row.conversionFactor}
                                                                    onValueChange={(e) => this.updateConversionRow(row.id, 'conversionFactor', e.value)}
                                                                    placeholder="Factor"
                                                                    inputStyle={{ width: '130px' }}
                                                                />
                                                                <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>x</span>
                                                                <Dropdown
                                                                    options={this.props.unitList || []}
                                                                    value={row.toUnit}
                                                                    onChange={(e) => this.updateConversionRow(row.id, 'toUnit', e.value)}
                                                                    placeholder="To Unit"
                                                                    style={{ width: '160px' }}
                                                                    {...DROPDOWN_CONFIG}
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                    <Column
                                                        header="Action"
                                                        style={{ width: '70px', textAlign: 'center' }}
                                                        body={(row) => (
                                                            <Button
                                                                icon="pi pi-trash"
                                                                className="p-button-danger p-button-text"
                                                                onClick={() => this.deleteConversionRow(row.id)}
                                                            />
                                                        )}
                                                    />
                                                </DataTable>
                                            </div>
                                        </div>

                                        {/* Menu Component Table */}
                                        <div className="p-col-12">
                                            <div className="card card-w-title">
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <h1>Menu Component</h1>
                                                    <Button
                                                        label="Add Row"
                                                        icon="pi pi-plus"
                                                        className="p-button-sm"
                                                        onClick={this.addComponentRow}
                                                    />
                                                </div>

                                                <DataTable value={this.state.componentRows}>
                                                    <Column
                                                        header="Menu Component"
                                                        body={(row) => (
                                                            <Dropdown
                                                                options={this.props.MenuComponentList || []}
                                                                value={row.menuComponent}
                                                                onChange={(e) => this.updateComponentRow(row.id, 'menuComponent', e.value)}
                                                                placeholder="Select Menu Component"
                                                                style={{ width: '100%' }}
                                                                {...DROPDOWN_CONFIG}
                                                            />
                                                        )}
                                                    />
                                                    <Column
                                                        header="Portion"
                                                        body={(row) => (
                                                            <InputNumber
                                                                value={row.portion}
                                                                onValueChange={(e) => this.updateComponentRow(row.id, 'portion', e.value)}
                                                                placeholder="Portion"
                                                                mode="decimal"
                                                                minFractionDigits={0}
                                                                maxFractionDigits={4}
                                                            />
                                                        )}
                                                    />
                                                    <Column
                                                        header="Unit"
                                                        body={(row) => (
                                                            <Dropdown
                                                                options={this.props.unitList || []}
                                                                value={row.unit}
                                                                onChange={(e) => this.updateComponentRow(row.id, 'unit', e.value)}
                                                                placeholder="Select Unit"
                                                                style={{ width: '100%' }}
                                                                {...DROPDOWN_CONFIG}
                                                            />
                                                        )}
                                                    />
                                                    <Column
                                                        header="Action"
                                                        style={{ width: '70px', textAlign: 'center' }}
                                                        body={(row) => (
                                                            <Button
                                                                icon="pi pi-trash"
                                                                className="p-button-danger p-button-text"
                                                                onClick={() => this.deleteComponentRow(row.id)}
                                                            />
                                                        )}
                                                    />
                                                </DataTable>
                                            </div>
                                        </div>

                                        {/* Functional Details */}
                                        <div className="p-col-12">
                                            <div className="card card-w-title">
                                                <h1>Functional Details</h1>
                                                <div className="p-grid">
                                                    <div className="p-col-12 p-md-6 p-lg-4">
                                                        <label className="label" htmlFor="theStory">The Story</label>
                                                        <div className="mt1">
                                                            <InputTextarea rows={3} cols={30} className="width100" id="theStory" name="theStory"
                                                                value={this.state.theStory} onChange={this.change}
                                                                placeholder="The Story" autoResize={true} />
                                                        </div>
                                                    </div>
                                                    <div className="p-col-12 p-md-6 p-lg-4">
                                                        <label className="label" htmlFor="character">Character</label>
                                                        <div className="mt1">
                                                            <InputTextarea rows={3} cols={30} className="width100" id="character" name="character"
                                                                value={this.state.character} onChange={this.change}
                                                                placeholder="Character" autoResize={true} />
                                                        </div>
                                                    </div>
                                                    <div className="p-col-12 p-md-6 p-lg-4">
                                                        <label className="label" htmlFor="chiefNote">Chief Note</label>
                                                        <div className="mt1">
                                                            <InputTextarea rows={3} cols={30} className="width100" id="chiefNote" name="chiefNote"
                                                                value={this.state.chiefNote} onChange={this.change}
                                                                placeholder="Chief Note" autoResize={true} />
                                                        </div>
                                                    </div>
                                                    <div className="p-col-12">
                                                        <label className="label" style={{ display: 'block' }}>Method</label>
                                                        <div className="mt1">
                                                            <Editor style={{ height: '320px' }} placeholder="Method"
                                                                value={toEditorHtml(this.state.method)}
                                                                onTextChange={this.changeMethod} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-lg-12">
                                            <FooterButton
                                                access={accessButton}
                                                disabled={!isEnabled}
                                                type={this.state.type.toLowerCase()}
                                                save={this.add}
                                                reset={this.resetData}
                                                to={redirectURL}
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        tableLists: state.master.tableLists,
        unitList: state.keyword.uom,
        CategoryList: state.keyword.Menucategory,
        modifierList: state.keyword.modifier,   // ← modifier master from Redux
        KitchenList: state.keyword.Kitchen,
        StoreList: state.keyword.StorageLocation,
        IngredientList: state.keyword.Ingredient,
        MenuComponentList: state.keyword.MenuComponent !== undefined ? state.keyword.MenuComponent : [],
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        getMasterTableList: (table, companyId) => dispatch(actions.getMasterTableList(table, companyId)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddMenuitem);